<template>
  <div class="report-result-box">
    <template>
      <div class="report-table" ref="reportTask">
        <!-- <reason-grid :columns="reasonColumns" :data="reasonMeasureList" :height="650"></reason-grid> -->

        <table>
          <colgroup>
            <col style="width:26%" />
            <col style="width:7%" />
            <col style="width:5%" />
            <col style="width:4%" />
            <col style="width:53%" />
            <col style="width:5%" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th style=" text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">Task명</th>
              <th style=" text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">기간</th>
              <th style=" text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">담당자</th>
              <th style=" text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">상태</th>
              <!-- <th>가중치</th> -->
              <th style=" text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">내용</th>
              <th style=" text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">첨부파일</th>
            </tr>
            <tr v-for="(item, i) in tempList" :key="i" :style="{ background: item.taskLevel == 1 ? '#e9ecef' : '' }">
              <td style="vertical-align:middle; border: 1px solid #cccccc; border-collapse: collapse;">
                <div :style="`padding-left: ${item.width}px;`" v-html="item.taskNm"></div>
              </td>
              <td style="vertical-align:middle; text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">
                {{ toDate(item.startDate) }} <br />
                {{ toDate(item.endDate) }}
              </td>
              <td style="vertical-align:middle; text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">{{ item.userName }}</td>
              <td style="vertical-align:middle; text-align: center; border: 1px solid #cccccc; border-collapse: collapse;">{{ item.taskStatusNm }}</td>
              <td style="vertical-align:middle; border: 1px solid #cccccc; border-collapse: collapse;">
                <div v-if="item.taskContent != null" class="ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred" style="overflow-y:auto;" contenteditable="false">
                  <div v-html="item.taskContent"></div>
                </div>
              </td>
              <td style="vertical-align:middle; border: 1px solid #cccccc; border-collapse: collapse;">
                <com-upload-file :read="true" :fileList="getFiles(i)" v-if="item.taskfile.length > 0"></com-upload-file>
                <!-- <com-upload-file :read="true" :fileList="item.taskfile"></com-upload-file> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import ComUploadFile from "@/components/common/global/ComUploadFile";

export default {
  components: {
    ComUploadFile
  },
  props: {
    prjInfo: {
      type: Object,
      required: false
    },
    glPrjInfo: {
      type: Object,
      required: false
    },
    glTaskList: {
      type: Array,
      required: false
    },
    glTaskFileList: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      taskList: []
    };
  },
  computed: {
    tempList() {
      let tmp = [];
      let tmp1 = [];
      let temp1 = this.glTaskList.filter(item => item.taskLevel == 1);
      let temp2 = this.glTaskList.filter(item => item.taskLevel == 2);
      let temp3 = this.glTaskList.filter(item => item.taskLevel == 3);
      for (let i = 0; i < temp1.length; i++) {
        tmp.push(temp1[i]);
        tmp.push(...temp2.filter(item => item.parentTaskId == temp1[i].taskId));
      }

      for (let i = 0; i < tmp.length; i++) {
        tmp1.push(tmp[i]);
        tmp1.push(...temp3.filter(item => item.parentTaskId == tmp[i].taskId));
      }

      return tmp1;
    }
  },
  mounted() {
    this.initClickImg();
  },
  methods: {
    toDate(val) {
      if (val != null && val.length === 8) return val.substr(0, 4) + "-" + val.substr(4, 2) + "-" + val.substr(6, 2);
      else return val;
    },
    openAtchFilePop(type) {
      this.$emit("openFile", type);
    },
    getFiles(i) {
      return this.glTaskList[i].taskfile;
    },
    getStyle(w) {
      return this.glTaskList[w].taskfile;
    },
    initClickImg() {
      let imgList = document.querySelectorAll("figure>img");

      for (let i = 0; i < imgList.length; i++) {
        let img = imgList[i];
        img.onload = function() // 이미지 로딩 완료 시 실행되는 함수
        {
          //var width = myImg.width; // 정확한 이미지 폭 알 수 있음.
          //img.addEventListener('click', this.image_popup(img.src));
          img.addEventListener("click", function() {
            var imgObj = new Image();
            imgObj.src = img.src;
            // let imageWin = window.open(
            //   '',
            //   'profile_popup',
            //   'width=' +
            //     img.naturalWidth +
            //     'px, height=' +
            //     img.naturalHeight +
            //     'px',
            // );
            let imageWin = window.open("", "profile_popup", "width=" + window.innerWidth + "px, height=" + window.outerHeight + "px");
            imageWin.document.write("<html><body style='margin:0'>");
            imageWin.document.write("<a href=javascript:window.close()><img src='" + imgObj.src + "' border=0 style='width: 100%;'></a>");
            imageWin.document.write("</body><html>");
            imageWin.document.title = imgObj.src;
          });
        };
      }
    }
  }
};
</script>
